/** @type {import("@mui/material").SxProps<Theme>} */
const styles = theme => ({
  deviceCard: {
    height: 200,
  },
  deviceImage: { m: '0 auto', height: { xs: 200 } },
  price: {
    paddingTop: 1,
    color: theme.palette.primary.textColor3,
  },
  mbbPrice: {
    paddingTop: 1,
    color: theme.palette.primary.offerMain,
  },
  mbbDeviceCost: {
    paddingTop: 1,
    color: theme.palette.primary.offerMain,
    paddingRight: '0.313em',
  },
  cardBox: {
    cursor: 'pointer',
    p: '1rem',
    [theme.breakpoints.down('sm')]: {
      p: '1.5rem 1.5rem 0.5rem 1.5rem',
    },
  },
  cta: {
    width: '4.5rem',
    height: '1.875rem',
    cursor: 'pointer',
    borderColor: theme.palette.primary.buttonColor,
    border: `2px solid ${theme.palette.primary.buttonColor}`,
    color: theme.palette.primary.buttonColor,
    background: theme.palette.primary.backgroundColor2,
    [theme.breakpoints.up('sm')]: {
      '&:hover': {
        background: theme.palette.primary.buttonColor,
        color: theme.palette.secondary.contrastText,
      },
    },
  },
  submitCTAContainer: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '0.875rem',
    paddingBottom: '3.75rem',
    [theme.breakpoints.down('sm')]: {
      paddingTop: '0.375rem',
      paddingLeft: '1.8rem',
      paddingRight: '1.8rem',
    },
  },
  submitCTA: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    border: `3px solid ${theme.palette.primary.buttonColor}`,
    textTransform: 'capitalize',
    width: '6.625rem',
    height: '40px',
    background: theme.palette.primary.buttonColor,
    color: theme.palette.secondary.contrastText,
    // boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow1Dark} ,0px 10px 14px 1px ${theme.palette.primary.boxShadow1Medium} ,0px 4px 18px 3px ${theme.palette.primary.boxShadow1Lite}`,
    '&:hover': {
      border: `3px solid ${theme.palette.primary.buttonPrimaryHoverColor}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
      // boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow}`,
    },
  },
  addonCardContainer: {
    alignItems: 'center',
    [theme.breakpoints.up('xs')]: {
      justifyContent: 'center',
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'center',
    },
  },
  addon_cards_description: {
    [theme.breakpoints.up('md')]: {
      minHeight: '90px',
    },
  },
  addon_cards: {
    borderRadius: '10px',
    boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow2Dark}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow2Medium}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}`,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  addonCard_content_img: {
    height: 'fit-content',
    [theme.breakpoints.up('md')]: {
      height: 'auto',
    },
  },
  addonCard_content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: 2,
    '& #tvChannelPopup': {
      color: theme.palette.primary.textColor3,
    },
  },
  mbbMainTitleDiv: {
    display: 'flex',
    height: '1.5rem',
    marginBottom: '0.5rem',
  },
  mbbTitleDiv: {
    display: 'flex',
    alignItems: 'center',
  },
  mbbOutOfStockTextMainDiv: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '50%',
  },
  mbbOutOfStockTextDiv: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.secondary.mobileActiveToggleBackground,
    opacity: 0.3,
    borderRadius: '1.25rem',
    padding: '0.188rem 0.25rem 0.188rem 0.25rem',
    width: '4.688rem',
    height: '1rem',
  },
  mbbOutOfStockText: {
    color: theme.palette.primary.contrastText,
  },
  selectNextOfferMainContainer: {
    background: `linear-gradient(0deg, ${theme.palette.primary.boxShadow3Dark} 0%, ${theme.palette.primary.boxShadow3Dark} 100%), ${theme.palette.primary.offerTag}`,
    borderRadius: '0.25rem',
    padding: '0.5rem 1rem',
    display: 'flex',
    alignItems: 'center',
    marginTop: '1rem',
  },
  reportProblemLogoDiv: {
    marginRight: '0.5rem',
    display: 'flex',
  },
  addon_priceCtaContainer: {
    paddingTop: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'end',
  },
  addon_cards_selected: {
    borderRadius: '10px',
    boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow2Dark}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow2Medium}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}`,
    // border: `3px solid ${theme?.palette.secondary.activeSlide}`,
  },
  addonType_Grid: {
    display: 'inline-flex',
    paddingLeft: 2,
    paddingTop: 2,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '1.5rem',
    },
  },
  a_month: {
    color: theme.palette.primary.textColor3,
    opacity: '54%',
    paddingTop: { xs: 2.4 },
    paddingLeft: 0.5,
  },
  addonContainer: {
    maxWidth: { sm: 450, md: 'lg' },
    margin: '0 auto',
    paddingBottom: '1.125rem',
  },
  addonCtaSelected: {
    width: '7.5rem',
    paddingLeft: '1rem',
    background: theme.palette.primary.buttonColor,
    border: `3px solid ${theme.palette.primary.buttonColor}`,
    color: theme.palette.secondary.contrastText,
    '&:hover': {
      border: `3px solid ${theme.palette.primary.buttonPrimaryHoverColor}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
    },
  },
  addonCtaCheck: {
    color: theme.palette.secondary.contrastText,
    marginLeft: '0.606rem',
  },
  faqContainerSuperMain: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: '6rem',
  },
});

export default styles;
